import React, { useEffect, useMemo } from 'react'
import ProgramEditingSubSection from './Components/ProgramEditingSubSection'
import ProgramOption from './Components/ProgramOption'
import Text from 'core-system/Text'
import TextField from 'core-system/TextField'
import { couponType } from '../Shared/types'
import { COUPON_INITIAL_STATE } from './ProgramEditingSlice'
import { Merchant } from 'redux/programs/programsTypes'
import wordings from '../Shared/wordings.json'

interface CouponProgramEditingProps {
  coupon: couponType
  changeMerchantIds: (value: string[]) => void
  changeMerchantsEnabled: (value: boolean) => void
  getCouponMerchants: () => void
  changeCouponCode: (value: string) => void
}

const CouponProgramEditing = ({
  coupon = COUPON_INITIAL_STATE,
  changeMerchantIds,
  changeMerchantsEnabled,
  getCouponMerchants,
  changeCouponCode,
}: CouponProgramEditingProps) => {
  const availableMerchantIds = useMemo(
    () => coupon.availableMerchants.map((merchant) => merchant.id),
    [coupon.availableMerchants]
  )

  const merchantsMap = useMemo(
    () =>
      coupon.availableMerchants.reduce<Dictionary<Merchant>>((acc, merchant) => {
        acc[merchant.id] = merchant
        return acc
      }, {}),
    [coupon.availableMerchants]
  )

  const hasMerchant = coupon.merchantsEnabled && coupon.merchantIds.length > 0

  useEffect(() => {
    getCouponMerchants()
  }, [])

  return (
    <>
      <ProgramEditingSubSection isLastSection={!hasMerchant}>
        <ProgramOption
          type='coupon'
          active={coupon.merchantsEnabled}
          activeMerchantIds={coupon.merchantIds}
          availableMerchantIds={availableMerchantIds}
          providersMap={merchantsMap}
          selectorModalTitle='Select the merchant'
          singleSelect
          handleProviderChange={changeMerchantIds}
          handleToggle={() => changeMerchantsEnabled(!coupon.merchantsEnabled)}
        />
      </ProgramEditingSubSection>
      {hasMerchant && (
        <ProgramEditingSubSection isLastSection>
          <Text variant='h5' marginBottom='1rem'>
            {wordings.coupon.codeLabel}
          </Text>
          <TextField
            value={coupon.couponCode}
            onChange={(e) => changeCouponCode(e.target.value)}
            placeholder={wordings.coupon.codePlaceholder}
          />
        </ProgramEditingSubSection>
      )}
    </>
  )
}

export default React.memo(CouponProgramEditing)
